import script from "./ToolPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolPage.vue?vue&type=script&setup=true&lang=js"

import "./ToolPage.vue?vue&type=style&index=0&id=b4434244&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4434244"]])

export default __exports__